module.exports = __webpack_public_path__ + "img/Lane 1890.b361ddf1.jpg";